pointman.define('m/messenger', function () {
	'use strict';
	//消息分割符
	var msgSpliter = '@=_=@';
	//当前窗口
	var currentWin = null;
	//消息来源窗口
	var originWin = null;
	/*
	 * 消息从哪里发过来
	 * fromFrame: 消息从iframe发出
	 * fromParent: 消息从父窗口发出
	 */
	var msgTransfer = null;
	// 已注册事件
	var attachedEvents = [];
	var IE = {
		//Unique Id
		uid: 0,
		//Head Id 当前已处理到的 Id
		hid: -1,
		//发送消息队列
		q: [],
		//发送消息队列定时器
		tm: 0,
		/**
		 * 发送跨域消息
		 * @param {Object} target iframe.contentWindow|parent
		 * @param {String} jsonStr
		 */
		postMessage: function (target, jsonStr) {
			var uid = ++IE.uid;
			var q = IE.q;
			var item = {
				name: (+new Date()) + '' + uid + '^' + document.domain + '&' + jsonStr,
				uid: uid,
				target: target
			};
			q.push(item);
			if (!IE.tm) {
				IE.tm = setInterval(function () {
					var q = IE.q;
					if (q.length === 0 || q[0].uid <= IE.hid) {
						return;
					}
					var item = q[0];
					IE.hid = item.uid;
					item.target.name = item.name;
				}, 10);
			}
		},
		/**
		 * window.name 监听方式
		 */
		ListenerMessage: function (win, handler) {
			var lastName = '';
			var reName = /^(\d+?)\^(.+?)&(.*?)$/;

			function onNameChanged() {
				if (!win) {
					return false;
				} else {
					var name = win.name; //=window.name
					//如果和上次不一样，则获取新数据
					if (name !== lastName) {
						// 出队列，
						IE.q.shift();

						lastName = name;
						var ms = reName.exec(name);
						if (!ms) {
							return;
						}

						//模拟 postMessage event 参数
						handler && handler({
							origin: ms[2],
							data: ms[3]
						});
					}
				}
			}

			setInterval(onNameChanged, 10);
		}
	};

	function messageHandler(ev) {
		try {
			var data = ev.data.split(msgSpliter);
			var eventType = data[0];
			var msgData = data[1];
			//激活事件
			for (var i = 0, len = attachedEvents.length; i < len; i++) {
				if (attachedEvents[i].event === eventType) {
					attachedEvents[i].callback(msgData);
				}
			}
		} catch (e) {
		}
	}

	return {
		/*
		 * 使用消息模块前需要先注册窗口，如果需要发送消息需要明确消息传递形式（obj.transfer）
		 * obj.currentWin
		 * obj.originWin
		 * obj.msgTransfer
		 */
		initListener: function (obj) {
			//当前窗口
			currentWin = obj.currentWin;
			//消息来源窗口
			originWin = obj.originWin;
			//消息传递形式
			msgTransfer = obj.msgTransfer;

			if (currentWin && originWin && msgTransfer) {
				//在当前窗口上监听postmessage事件
				if (currentWin.postMessage) {
					if (currentWin.addEventListener) {
						currentWin.addEventListener('message', messageHandler, false);
					} else if (currentWin.attachEvent) {
						currentWin.attachEvent('onmessage', messageHandler);
					}
				} else {
					//始终确保在iframe上监听window.name变化
					if (msgTransfer == 'fromFrame') {
						//在父窗口中监听iframe发来的消息
						IE.ListenerMessage(originWin, messageHandler);
					} else {
						//在iframe中监听父窗口发送的消息
						IE.ListenerMessage(currentWin, messageHandler);
					}
				}
			}
		},
		//注册消息
		register: function (event, callback) {
			attachedEvents.push({
				event: event,
				callback: callback
			});
		},
		/**
		 * 发送消息.
		 * @param {String} obj.type 消息类型.
		 * @param {string} obj.content 消息内容
		 */
		send: function (obj) {
			//发给目标窗口的数据
			var postData = obj.type + msgSpliter + obj.content;

			if (currentWin && originWin && msgTransfer) {
				if (originWin.postMessage) {
					/*
					 * initListener方法注册的是监听函数
					 * 而发送消息与监听消息刚好相反，所以这里需要往originWin发送消息
					 * 支持postmessage时往目标窗口发送消息
					 */
					originWin.postMessage(postData, '*');
				} else {
					//始终确保写iframe的window.name
					if (msgTransfer == 'fromFrame') {
						//在父窗口中监听iframe发来的消息
						IE.postMessage(originWin, postData);
					} else {
						//在iframe中监听父窗口发送的消息
						IE.postMessage(currentWin, postData, '*');
					}
				}
			}
		}
	};
});
